/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Terminal outcome of a command invocation, recorded once per call in the CommandAuditLog.
 */
export enum EnumCommandOutcome {
    /**
     * Handler ran to completion and returned a successful result.
     */
    Succeeded = 0,
    /**
     * Validation failed before Handle was called.
     */
    Rejected = 1,
    /**
     * Handler was invoked but failed with an error (business or technical).
     */
    Failed = 2,
    /**
     * Caller did not hold the permissions required by the command; Handle was not invoked.
     */
    Forbidden = 3,
}
